import { GenericTableColumn, GenericTableColumnType } from 'inside-fifa/api/generic-tables/dto';

export const getDefaultSettings = (type: GenericTableColumnType): Partial<GenericTableColumn> => {
    switch (type) {
        case GenericTableColumnType.FdcpAssociation:
        case GenericTableColumnType.FdcpConfederation:
            return {
                isLogoVisible: true,
            };
        default:
            return {};
    }
};
